import { type ReactNode } from "react";

import * as DialogPrimitive from "@radix-ui/react-dialog";

import { useNotificationCenter } from "../NotificationCenter.context";

type TriggerRenderProps = {
  unreadCount: number;
  isOpen: boolean;
};

type Props = {
  children: ReactNode | ((props: TriggerRenderProps) => ReactNode);
  className?: string;
};

export const NotificationCenterTrigger = ({ children, className }: Props) => {
  const { unreadCount, isOpen } = useNotificationCenter();

  return (
    <DialogPrimitive.Trigger asChild className={className}>
      {typeof children === "function"
        ? children({ unreadCount, isOpen })
        : children}
    </DialogPrimitive.Trigger>
  );
};
